<template>
  <div class="reject-all-modal-content">
      <div class="modal-body">
        <p class="question">האם המועמד בכלל לא רלוונטי לתחום? או שיש לדחות את ההצעות שלו נקודתית?</p>

        <div class="options-container">
          <div class="option-card" :class="{ 'selected': selectedOption === 'not_relevant' }" @click="selectOption('not_relevant')">
            <input
              type="radio"
              name="reject_type"
              value="not_relevant"
              v-model="selectedOption"
              id="not_relevant"
            />
            <label for="not_relevant">
              <strong>לא רלוונטי לתחום</strong>
              <p class="option-description">שינוי לסטטוס: Admin Rejected</p>
            </label>
          </div>

          <div class="option-card" :class="{ 'selected': selectedOption === 'specific_reject' }" @click="selectOption('specific_reject')">
            <input
              type="radio"
              name="reject_type"
              value="specific_reject"
              v-model="selectedOption"
              id="specific_reject"
            />
            <label for="specific_reject">
              <strong>לדחות הצעות נקודתית</strong>
              <p class="option-description">שינוי לסטטוס: Expired Before Sent</p>
            </label>
          </div>
        </div>

        <div v-if="selectedOption === 'specific_reject'" class="reason-input">
          <label for="reject_reason">סיבת הדחייה:</label>
          <textarea
            id="reject_reason"
            v-model="rejectReason"
            placeholder="הזן את סיבת הדחייה..."
            rows="3"
            class="form-control"
          ></textarea>
        </div>

        <div v-if="selectedOption" class="message-preview">
          <strong>הודעה שתשמר:</strong>
          <p>{{ generateMessage() }}</p>
        </div>
      </div>

      <div class="modal-footer">
        <button @click="closeModal" class="btn btn-secondary">ביטול</button>
        <button
          @click="confirmRejectAll"
          class="btn btn-danger"
          :disabled="!canConfirm"
        >
          אישור דחייה
        </button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'RejectAllOffersModal',

  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      selectedOption: null,
      rejectReason: ''
    }
  },

  computed: {
    modalData () {
      return this.payload.data || this.payload
    },
    recruiterName () {
      return this.modalData.recruiterName || 'אדמין'
    },
    onConfirm () {
      return this.modalData.onConfirm || null
    },
    canConfirm () {
      if (!this.selectedOption) return false
      if (this.selectedOption === 'specific_reject' && !this.rejectReason.trim()) {
        return false
      }
      return true
    }
  },

  methods: {
    selectOption (option) {
      this.selectedOption = option
    },

    generateMessage () {
      const recruiter = this.recruiterName || 'מגייסת'

      if (this.selectedOption === 'not_relevant') {
        return `Reject All על ידי ${recruiter} מאחר ומועמד לא רלוונטי לתחום`
      } else if (this.selectedOption === 'specific_reject') {
        const reason = this.rejectReason.trim() || '[יש להשלים]'
        return `Rejected All על ידי ${recruiter} בגלל ש${reason}`
      }
      return ''
    },

    confirmRejectAll () {
      if (!this.canConfirm) return

      const payload = {
        option: this.selectedOption,
        message: this.generateMessage(),
        reason: this.selectedOption === 'specific_reject' ? this.rejectReason : null
      }

      // Call the onConfirm callback
      if (this.onConfirm) {
        this.onConfirm(payload)
      }

      // Close the modal
      this.closeModal()
    },

    closeModal () {
      this.resetModal()
      // Use Vuex mutation to close the modal
      this.$store.commit('modals/remove', this.payload)
    },

    resetModal () {
      this.selectedOption = null
      this.rejectReason = ''
    }
  }
}
</script>

<style scoped>
.reject-all-modal-content {
  background: white;
}

.modal-body {
  padding: 20px;
}

.question {
  font-size: 1.1rem;
  margin-bottom: 20px;
  color: #333;
  font-weight: 500;
  text-align: right;
}

.options-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.option-card {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-align: right;
}

.option-card:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
}

.option-card.selected {
  border-color: #007bff;
  background-color: #e7f3ff;
}

.option-card input[type="radio"] {
  margin-top: 3px;
  cursor: pointer;
}

.option-card label {
  cursor: pointer;
  flex: 1;
  margin: 0;
}

.option-card strong {
  display: block;
  margin-bottom: 5px;
  font-size: 1rem;
}

.option-description {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

.reason-input {
  margin: 20px 0;
  text-align: right;
}

.reason-input label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.reason-input textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  resize: vertical;
  direction: rtl;
  text-align: right;
}

.reason-input textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.message-preview {
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  margin-top: 20px;
  text-align: right;
}

.message-preview strong {
  display: block;
  margin-bottom: 8px;
  color: #333;
}

.message-preview p {
  margin: 0;
  color: #666;
  font-style: italic;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background-color: #c82333;
}

.btn-danger:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
